import { MovingUnderlineNav } from "@/components/moving-underline-nav";
import { PageContent, PageHeader } from "@/components/page-components";
import { projects } from "@papier/shared";
import { Button } from "@papier/ui/components/ui/button";
import { createFileRoute, Link, linkOptions, Outlet } from "@tanstack/react-router";
import { ImageIcon, Inbox, Info, LayoutDashboard, Logs, Settings } from "lucide-react";
import { z } from "zod";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout")({
  component: ProjectLayout,
  params: {
    parse: (params) => {
      return z.object({ projectSlug: projects.shape.slug }).parse(params);
    },
  },
  loader: ({ context: { queryClient, trpc }, params }) => {
    return queryClient.ensureQueryData(trpc.projects.getBySlug.queryOptions(params));
  },
  head: ({ loaderData }) => ({
    meta: [{ title: `Papier - ${loaderData?.name || "Project"}` }],
  }),
});

const navigationItems = linkOptions([
  {
    title: "Templates",
    icon: LayoutDashboard,
    to: "/projects/$projectSlug",
    from: "/projects/$projectSlug",
  },
  {
    title: "Logs",
    icon: Logs,
    to: "/projects/$projectSlug/logs",
    from: "/projects/$projectSlug",
  },
  {
    title: "Virtual Inbox",
    icon: Inbox,
    to: "/projects/$projectSlug/virtual-inbox",
    from: "/projects/$projectSlug",
  },
  {
    title: "Media",
    icon: ImageIcon,
    to: "/projects/$projectSlug/media",
    from: "/projects/$projectSlug",
  },
  {
    title: "Settings",
    icon: Settings,
    to: "/projects/$projectSlug/settings",
    from: "/projects/$projectSlug",
  },
  {
    title: "About",
    icon: Info,
    to: "/projects/$projectSlug/about",
    from: "/projects/$projectSlug",
  },
]);

function ProjectLayout() {
  return (
    <>
      <PageHeader>
        <div className="no-scrollbar overflow-x-auto px-4 pt-1">
          <MovingUnderlineNav>
            {navigationItems.map((item) => {
              return (
                <Button asChild key={item.title} variant="ghost">
                  <Link
                    from={item.from}
                    to={item.to}
                    className="hover:bg-transparent! relative rounded-none px-4 py-2 transition-colors duration-300 ease-in-out"
                    inactiveProps={{
                      className: "text-muted-foreground hover:text-primary-foreground",
                    }}
                    activeProps={{
                      className: "text-foreground",
                    }}
                    activeOptions={{ exact: true, includeSearch: false }}
                  >
                    <item.icon className="size-4" />
                    <span>{item.title}</span>
                  </Link>
                </Button>
              );
            })}
          </MovingUnderlineNav>
        </div>
      </PageHeader>
      <PageContent className="mx-auto flex w-full max-w-7xl flex-col gap-6">
        <Outlet />
      </PageContent>
    </>
  );
}
